import { css } from 'lit';
export default css `
  :host {
    box-sizing: border-box;
    --private-box-shadow: 6px 6px 10px 28px rgba(255, 255, 255, 0.73);
  }

  .chips {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    box-sizing: border-box;
  }

  .chips__list {
    position: relative;
    display: flex;
    width: auto;
    overflow: hidden;
    white-space: nowrap;
  }

  .chips__list > amityeko-chip {
    position: relative;
  }

  amityeko-chip:not(:last-child) {
    margin-right: 8px;
  }

  /* Scroll */
  .chips__scroll-btn {
    position: absolute;
    z-index: 99;
    cursor: pointer;
    border-radius: 50%;
    background-color: white;
    box-shadow: var(--private-box-shadow);
    transition: all 5s ease-in-out;
  }

  .chips__scroll-btn--left {
    left: 0;
  }

  .chips__scroll-btn--right {
    right: 0;
  }

  .chips--no-scroll .chips__scroll-btn,
  .chips__scroll-btn--hidden {
    display: none;
  }
`;
//# sourceMappingURL=styles.js.map